// extracted by mini-css-extract-plugin
export var ContactSection = "contact-module--ContactSection--YGZ9E";
export var Container = "contact-module--Container--2wjy5";
export var FormGroup = "contact-module--FormGroup--15jEa";
export var Full = "contact-module--Full--V2OJz";
export var FormElement = "contact-module--FormElement--27UdY";
export var SubmitGroup = "contact-module--SubmitGroup--gMxcO";
export var TopTilt = "contact-module--TopTilt--vjr8M";
export var BottomTilt = "contact-module--BottomTilt--2BatU";
export var ShapeFill = "contact-module--ShapeFill--3NnFy";